import { z } from 'zod/v4';
import { $ZodType } from 'zod/v4/core';

import { VisualRunRateType, VisualScrapYieldType } from '../operation/enums';
import { columns } from './columns';

export const visualOperationTypeSchema = z.object(columns);

export type VisualOperationType = z.output<typeof visualOperationTypeSchema>;

export const visualOperationTypeConfiguratorSelect = [
  'id',
  'description',
  'resource_id',
  'setup_hrs',
  'setup_cost_per_hr',
  'run',
  'run_type',
  'run_cost_per_hr',
  'run_cost_per_unit',
  'bur_per_hr_run',
  'bur_per_hr_setup',
  'bur_per_operation',
  'bur_per_unit_run',
  'bur_percent_run',
  'bur_percent_setup',
  'scrap_yield_type',
  'scrap_yield_pct',
  'fixed_scrap_units',
] as const satisfies readonly (keyof VisualOperationType)[];

export type VisualOperationTypeConfiguratorRecord = Pick<
  VisualOperationType,
  (typeof visualOperationTypeConfiguratorSelect)[number]
>;

export const visualConfiguratorOperationTypeSchema = z.object({
  id: z.string().transform((s) => s.toUpperCase()),
  description: z.string().nullable(),
  resource_id: z
    .string()
    .nullable()
    .transform((s) => s?.toUpperCase() ?? null),
  setup_hrs: z.number().nullable(),
  setup_cost_per_hr: z.number().nullable(),
  run: z.number().nullable(),
  run_type: z
    .string()
    .nullable()
    .transform((v) => (v ? v.trim() : null))
    .pipe(z.enum(VisualRunRateType))
    .nullable(),
  run_cost_per_hr: z.number().nullable(),
  run_cost_per_unit: z.number().nullable(),
  bur_per_hr_run: z.number().nullable(),
  bur_per_hr_setup: z.number().nullable(),
  bur_per_operation: z.number().nullable(),
  bur_per_unit_run: z.number().nullable(),
  bur_percent_run: z.number().nullable(),
  bur_percent_setup: z.number().nullable(),
  scrap_yield_type: z
    .string()
    .nullable()
    .transform((v) => (v ? v.trim() : null))
    .pipe(z.enum(VisualScrapYieldType))
    .nullable(),
  scrap_yield_pct: z.number().nullable(),
  fixed_scrap_units: z.number().nullable(),
} satisfies Record<
  (typeof visualOperationTypeConfiguratorSelect)[number],
  $ZodType
>);

export type VisualConfiguratorOperationTypeSchemaOutput = z.output<
  typeof visualConfiguratorOperationTypeSchema
>;
